import { PanelTitle } from "@shared/ui/PanelTitle";
import { Button } from "@shared/ui/Button";

type Props = {
  onStart: () => void;
};

export function OnboardingIntro({ onStart }: Props) {
  return (
    <PanelTitle
      title="Pollinator Program Onboarding"
      description="Please confirm a few details to make sure Pollinator is a good fit for you."
      className="flex-1"
      isInverted
    >
      <Button
        variant="primary"
        theme="dark"
        className="w-full mb-14 md:size-max md:mb-0"
        onClick={onStart}
        data-testid="onboarding-intro-start"
      >
        Get Started
      </Button>
    </PanelTitle>
  );
}

export default OnboardingIntro;
